export default "__VITE_ASSET__DUhNcQme__"